var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUploadImageDefault(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_2884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.166 8.87695H31.3604L30.5041 6.30791C29.9648 4.69028 28.4569 3.60352 26.7519 3.60352H18.2481C16.5431 3.60352 15.0352 4.69028 14.496 6.30791L13.6396 8.87695H11.5137V6.67969C11.5137 4.98349 10.1337 3.60352 8.4375 3.60352H6.67969C4.98349 3.60352 3.60352 4.98349 3.60352 6.67969V9.03621C1.53211 9.58184 0 11.4706 0 13.7109V36.5625C0 39.228 2.16853 41.3965 4.83398 41.3965H40.166C42.8315 41.3965 45 39.228 45 36.5625V13.7109C45 11.0455 42.8315 8.87695 40.166 8.87695ZM6.24023 6.67969C6.24023 6.43737 6.43737 6.24023 6.67969 6.24023H8.4375C8.67981 6.24023 8.87695 6.43737 8.87695 6.67969V8.87695H6.24023V6.67969ZM42.3633 36.5625C42.3633 37.7741 41.3776 38.7598 40.166 38.7598H4.83398C3.62241 38.7598 2.63672 37.7741 2.63672 36.5625V13.7109C2.63672 12.4994 3.62241 11.5137 4.83398 11.5137H14.5898C15.1573 11.5137 15.6611 11.1506 15.8405 10.6122L16.9973 7.14173C17.1772 6.60252 17.6797 6.24023 18.2481 6.24023H26.7519C27.3203 6.24023 27.8229 6.60252 28.0026 7.14164L29.1594 10.6122C29.3389 11.1506 29.8427 11.5137 30.4102 11.5137H40.166C41.3776 11.5137 42.3633 12.4994 42.3633 13.7109V36.5625Z",
    fill: "#1F3E74",
    stroke: "#1F3E74",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3203 16.7871C39.0484 16.7871 39.6387 16.1969 39.6387 15.4688C39.6387 14.7406 39.0484 14.1504 38.3203 14.1504C37.5922 14.1504 37.002 14.7406 37.002 15.4688C37.002 16.1969 37.5922 16.7871 38.3203 16.7871Z",
    fill: "#1F3E74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31641 14.1504H6.67969C5.9516 14.1504 5.36133 14.7407 5.36133 15.4688C5.36133 16.1968 5.9516 16.7871 6.67969 16.7871H9.31641C10.0445 16.7871 10.6348 16.1968 10.6348 15.4688C10.6348 14.7407 10.0445 14.1504 9.31641 14.1504Z",
    fill: "#1F3E74"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.1484,
    cy: 24.9609,
    r: 8.08594,
    fill: "#1F3E74"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_2884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadImageDefault);
export default __webpack_public_path__ + "static/media/icon-upload-image-default.ba7726c3bcb2d41b40d3525c90cbffc6.svg";
export { ForwardRef as ReactComponent };